var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 76,
    viewBox: "0 0 86 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.125 5.75C59.125 4.32446 59.6913 2.95731 60.6993 1.9493C61.7073 0.941293 63.0745 0.375 64.5 0.375H75.25C76.6755 0.375 78.0427 0.941293 79.0507 1.9493C80.0587 2.95731 80.625 4.32446 80.625 5.75V70.25H83.3125C84.0253 70.25 84.7088 70.5331 85.2129 71.0371C85.7169 71.5412 86 72.2247 86 72.9375C86 73.6503 85.7169 74.3338 85.2129 74.8379C84.7088 75.3419 84.0253 75.625 83.3125 75.625H2.6875C1.97473 75.625 1.29115 75.3419 0.787151 74.8379C0.283147 74.3338 0 73.6503 0 72.9375C0 72.2247 0.283147 71.5412 0.787151 71.0371C1.29115 70.5331 1.97473 70.25 2.6875 70.25H5.375V54.125C5.375 52.6995 5.94129 51.3323 6.9493 50.3243C7.95731 49.3163 9.32446 48.75 10.75 48.75H21.5C22.9255 48.75 24.2927 49.3163 25.3007 50.3243C26.3087 51.3323 26.875 52.6995 26.875 54.125V70.25H32.25V32.625C32.25 31.1995 32.8163 29.8323 33.8243 28.8243C34.8323 27.8163 36.1995 27.25 37.625 27.25H48.375C49.8005 27.25 51.1677 27.8163 52.1757 28.8243C53.1837 29.8323 53.75 31.1995 53.75 32.625V70.25H59.125V5.75Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartVector);
export default __webpack_public_path__ + "static/media/chart-vector.159a05772773bed20e3bc0c60d9379af.svg";
export { ForwardRef as ReactComponent };